export const DDUKDOC_BRAND_NAME = '뚝닥AI';

const LEGACY_BRAND_NAMES = new Set([
  'chatwoot',
  'beauchat',
  'mediwishware',
  'chat-dashboard',
]);

export const normalizeLegacyBrandName = name => {
  if (!LEGACY_BRAND_NAMES.has(name?.trim().toLowerCase())) return name;
  return DDUKDOC_BRAND_NAME;
};

// URLs, email addresses, code spans and interpolation names are integration contracts.
const BRAND_COPY =
  /(https?:\/\/[^\s<>"']+|[\w.+-]+@[\w.-]+\.\w+|`[^`]*`|\{[^}]*\})|(?<![\w./@-])(?:chatwoot|beauchat|mediwishware|chat-dashboard)(?![\w./@-])/gi;

export const replaceBrandName = (text, name = DDUKDOC_BRAND_NAME) =>
  text?.replace(BRAND_COPY, (match, protectedText) => protectedText || name);

export const brandMessages = messages => {
  if (typeof messages === 'string') return replaceBrandName(messages);
  if (Array.isArray(messages)) return messages.map(brandMessages);
  if (!messages || typeof messages !== 'object') return messages;
  return Object.fromEntries(
    Object.entries(messages).map(([key, value]) => [key, brandMessages(value)])
  );
};
